import {Col, FormGroup, Label, Row} from "reactstrap";
import {I18n} from "../../I18n/components/promoter";
import TagsInput from "react-tagsinput";
import React from "react";

const TagsInputRow = props => {
    const {lang, tags, validator} = props;
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for="tags">
                        {I18n[lang].tags}
                    </Label>
                    <TagsInput
                        inputProps={{
                            placeholder: `${I18n[lang].tags}`
                        }}
                        value={tags}
                        onChange={props.onTagsChange}
                        tagProps={{className: "react-tagsinput-tag bg-info text-white rounded"}}
                    />
                    {validator.showErrors('tags')}
                </FormGroup>
            </Col>
        </Row>
    )
}

export default TagsInputRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/TagsInputRow.js